import { styled } from 'linaria/react';

export const FloatingButton = styled.div`
	--floating-button-size: 62px;

	display: flex;
	align-items: center;
	justify-content: center;
	position: fixed;
	right: 32px;
	bottom: 32px;
	background: white;
	color: var(--blue500);
	width: var(--floating-button-size);
	height: var(--floating-button-size);
	border-radius: 50%;
	box-shadow: 0 3px 7px -3px rgba(0, 0, 0, 0.2), 0 6px 12px -2px rgba(70, 55, 95, 0.2);
	cursor: pointer;
	z-index: 1000;
`;
